import styled from 'styled-components';
import { darkgrey, grey } from 'styles/Colors';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 0 0 30px;
  gap: 10px;
  font-family: Lato;
`;

export const Title = styled.div`
  color: ${darkgrey};
  font-size: 15px;
  font-weight: 700;
  line-height: 21px;
`;

export const Description = styled.div`
  color: ${grey};
  font-size: 13px;
  font-weight: 400;
  line-height: 18.2px;
`;

export const HeightOffset = styled.div`
  color: ${grey};
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;

  span {
    font-weight: 700;
  }
`;

export const Divider = styled.div`
  height: 16px;
  width: 1px;
  background-color: ${grey};
`;

export const HeightOffsetList = styled.div`
  display: flex;
  gap: 8px;
`;
